import React, { PropTypes } from "react";
import SizeRow from "./SizeRow";

import "./SizeTable.css";

const SizeTable = ({ brand, gender, type }) => {
  return(
    <table id="size-table" className="table table-hover">
      <thead>
        <tr>
          <th>Size</th>
          <th className="text-right">Height</th>
          {brand.sizes[0].maxWeight !== 9999 &&
            <th className="text-right">Weight</th>
          }
        </tr>
      </thead>
      {
        brand.sizes.map(
          (size, index) => <SizeRow brand={brand} gender={gender} key={index} size={size} type={type}/>
        )
      }
    </table>
  );
};

SizeTable.propTypes = {
  brand: PropTypes.object.isRequired,
  gender: PropTypes.string.isRequired,
  type: PropTypes.string.isRequired,
};

export default SizeTable;


/** WEBPACK FOOTER **
 ** ./src/components/Brands/SizeTable.js
 **/